module.exports = __webpack_public_path__ + "img/csr_110923_F.55dbb9c1.jpg";